<template>
  <div>
    <view-table
        ref="viewTable"
        :limits="limits"
        :filter="filter"
        module="basic"
        url="esops/file"
        :columns-property="columnsProperty"
        :table-select="false"
        @reset="resetHandle"
        @delete="deleteHandle"
        @addOrEdit="addEditHandle">
      <template slot="adSearch">
        <div class="vm-search">
          <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
            <el-form-item label="文件编号">
              <el-input v-model.trim="filter.esopNo" placeholder="请输入" clearable/>
            </el-form-item>
            <el-form-item label="文件名称">
              <el-input v-model.trim="filter.esopName" placeholder="请输入" clearable/>
            </el-form-item>
            <el-form-item label="文件属性">
              <el-select v-model="filter.fileType" placeholder="请选择" clearable>
                <el-option label="受控" :value="10"/>
                <el-option label="试行" :value="20"/>
                <el-option label="样品" :value="30"/>
              </el-select>
            </el-form-item>
            <el-form-item label="文件类别">
              <el-select
                  v-model="bindingCategory"
                  multiple
                  placeholder="请选择"
                  clearable
                  @change="handleSelectCategory">
                <!--          <el-option label="操作卡" :value="10"/>-->
                <el-option label="管理制度" :value="20"/>
                <el-option label="产品图纸" :value="30"/>
                <el-option label="承认书" :value="40"/>
                <el-option label="产品方案" :value="50"/>
                <el-option label="零部件图纸" :value="60"/>
                <el-option label="零部件展开图" :value="70"/>
                <el-option label="程序文件" :value="80"/>
                <el-option label="工艺文件" :value="90"/>
                <el-option label="供应商规格书" :value="100"/>
              </el-select>
            </el-form-item>
            <el-form-item label="物料编号">
              <el-input v-model.trim="filter.materialNo" placeholder="请输入" clearable/>
            </el-form-item>
            <el-form-item label="规格型号">
              <el-input v-model.trim="filter.specification" placeholder="请输入" clearable/>
            </el-form-item>
          </el-form>
        </div>
      </template>

      <template slot="actionBtn" slot-scope="scope">
        <el-button v-if="limits.download" type="primary" @click="downHandle(scope.row.filePath)">下载</el-button>
      </template>
    </view-table>
    <!-- 新增编辑 -->
    <file-manage-edit ref="fileEdit" @save-success="loadData(1)"/>
    <pdf-preview-index ref="pdfPreview"/>
    <file-record ref="fileRecord"/>
  </div>
</template>

<script>
  import ViewTable from "@/components/ViewTable";
  import FileManageEdit from "./FileManageEdit.vue";
  import PdfPreviewIndex from "@/views/information/Esop/PdfPreviewIndex";
  import FileRecord from "@/views/information/FileManagement/FileRecord";

  export default {
    name: "FileManageList",
    components: {
      ViewTable,
      FileManageEdit,
      PdfPreviewIndex,
      FileRecord,
    },
    data() {
      return {
        limits: {
          addAuth: this.$auth(511),
          editAuth: this.$auth(512),
          // delAuth: this.$auth(513),
          download: this.$auth(514),
        },
        filter: {
          esopNo: "",
          esopName: "",
          fileType: "",
          materialNo: "",
          specification: "",
          fileCategoryStr: "",
        },
        billId: "",
        billType: "",
        bindingCategory: [],
        columnsProperty: [
          {
            key: "esopNo",
            width: 120,
            align: "center",
            render: (h, params) => {
              return h(
                  "span",
                  {
                    style: {
                      color: "#2d8cf0",
                      cursor: "pointer",
                    },
                    on: {
                      click: () => {
                        this.replaceRecordClick(params.row);
                        // this.$refs.replaceRecord.open(params.row);
                      },
                    },
                  },
                  params.row.esopNo,
              );
            },
          },
          {
            key: "esopName",
            tooltip: true,
            minWidth: 200,
          },
          {
            key: "filePath",
            tooltip: true,
            width: 120,
            render: (h, params) => {
              return h(
                  "span", {
                    style: {
                      color: params.row.filePath.substring(params.row.filePath.lastIndexOf(".")).toUpperCase() == ".PDF" ? "#2d8cf0" : "",
                      cursor: params.row.filePath.substring(params.row.filePath.lastIndexOf(".")).toUpperCase() == ".PDF" ?"pointer":"",
                    },
                    on: {
                      click: () => {
                        if (params.row.filePath.substring(params.row.filePath.lastIndexOf(".")).toUpperCase() == ".PDF") {
                          this.download(params.row.filePath);
                        }
                      },
                    },
                  },
                  params.row.filePath,
              );
            },
          },
          {
            key: "action",
            width: this.$auth(512) ? 140 : 0,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },
    watch: {
      "filter.fileCategoryStr": {
        handler(val) {
          if (val) {
            this.bindingCategory = [];
            val.split(",").forEach((s) => {
              this.bindingCategory.push(parseInt(s));
            });
          }
        },
      },
    },
    methods: {
      replaceRecordClick(row) {
        this.$http
            .get("basic", `esops/${row.pkId}`)
            .then((resp) => {
              if (resp.success) {
                this.$refs.fileRecord.open(resp.data);
              }
            });
      },
      download(filePath) {
        this.$refs.pdfPreview.open(filePath);

        // this.$http.get("basic", `files/getDownloadUrl?key=${filePath}`).then((res) => {
        //   if (res.success) {
        //     // window.open(res.data);
        //     this.$refs.pdfPreview.open(res.data);
        //   }
        // });

        // this.$http.get("basic", `files/getDownloadUrl?key=${filePath}`).then((res) => {
        //   if (res.success) {
        //     this.$refs.pdfPreview.open(res.data);
        //   }
        // }).catch(() => {
        // });
      },

      downHandle(filePath) {
        this.$http.get("basic", `files/getDownloadUrl?key=${encodeURIComponent(filePath)}`).then((res) => {
          if (res.success) {
            window.open(res.data);
          }
        });
      },

      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },

      addEditHandle(row) {
        this.$refs.fileEdit.open(row);
      },

      // 删除
      deleteHandle(row) {
        this.$http.delete("basic", "esops", row.pkId).then((res) => {
          if (res.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },

      // 提交
      submitHandle(pkId) {
        this.$confirm("确定提交吗?", "提示", {type: "warning"}).then(() => {
          this.$http.post("basic", `esops/submit/${pkId}`).then((res) => {
            if (res.success) {
              this.$message.success("提交成功");
              this.loadData(1);
            }
          });
        });
      },

      handleSelectCategory(value) {
        if (value.length) {
          this.bindingStatusCategory = value;
          this.filter.fileCategoryStr = value.join(",");
        } else {
          this.bindingStatusCategory = [];
          this.filter.fileCategoryStr = "";
        }
      },
      otherAuth(row) {
        if (row.status === 0) {
          return {
            // editAuth: false,
            delAuth: false,
          };
        } else if (row.status === 5) {
          return {
            // editAuth: false,
            delAuth: true,
          };
        } else {
          return {
            // editAuth: true,
            delAuth: true,
          };
        }
      },
    },
  };
</script>

<style lang="scss">
.ivu-table td,
.ivu-table th {
  height: 37px;
  font-size: 13px;

  .el-button--mini {
    padding: 7px 10px;
  }
}
</style>
